// extracted by mini-css-extract-plugin
export default {"catagory":"catagory_catagory__T2758","catagory_container":"catagory_catagory_container__jAHMj"};